<!--列表查看视图-->
<template>
  <div>
    <template v-if="lob==='AI'">
      <ai-master-basic-tab v-if="masterFlag" ref="tabAIBasicMaster" :context="context" :action="action" view-source="salesDetail" :booking-agent-visible="bookingAgentVisible" />
      <ai-basic-tab v-else ref="tabAIBasic" :context="context" :action="action" view-source="salesDetail" :booking-agent-visible="bookingAgentVisible" />
    </template>
    <template v-else-if="lob==='AE'">
      <template v-if="masterFlag">
        <ae-tab-master-UICustom v-if="showUiCustom" ref="tabAEBasicMaster" :context="context" :action="action" view-source="salesDetail" />
        <ae-master-basic-tab v-else ref="tabAEBasicMaster" :context="context" :action="action" view-source="salesDetail" />
      </template>
      <template v-else>
        <ae-tab-general-UICustom v-if="showUiCustom" ref="tabAEBasic" :context="context" :action="action" view-source="salesDetail" />
        <ae-basic-tab v-else ref="tabAEBasic" :context="context" :action="action" view-source="salesDetail" />
      </template>
    </template>
    <template v-else-if="lob==='SI'">
      <si-master-basic-tab v-if="masterFlag" ref="tabSiBasicMaster" :context="context" :action="action" view-source="salesDetail" :booking-agent-visible="bookingAgentVisible" />
      <si-basic-tab v-else ref="tabSiBasic" :context="context" :action="action" view-source="salesDetail" :booking-agent-visible="bookingAgentVisible" />
    </template>
    <template v-else-if="lob==='SE'">
      <template v-if="masterFlag">
        <tab-booking-master-UICustom v-if="showUiCustom" ref="tabBookingMaster" :context="context" :action="action" class="se-basic-tab" view-source="salesDetail" />
        <tab-booking-master v-else ref="tabBookingMaster" :context="context" :action="action" class="se-basic-tab" view-source="salesDetail" />
      </template>
      <template v-else>
        <tab-booking-FCLUICustom v-if="showUiCustom" ref="tabBookingFCL" :context="context" :action="action" class="se-basic-tab" view-source="salesDetail" />
        <tab-booking-fcl v-else ref="tabBookingFCL" :context="context" :action="action" class="se-basic-tab" view-source="salesDetail" />
      </template>
    </template>
    <template v-else-if="lob==='RE'||lob==='RI'">
      <re-tab-booking-master v-if="masterFlag" ref="reTabBookingMaster" :context="context" :action="action" view-source="salesDetail" />
      <re-tab-booking-fcl v-else ref="reTabBookingFcl" :context="context" :action="action" view-source="salesDetail" />
    </template>
    <template v-else-if="lob==='IE'">
      <!-- 集卡拖车基础-->
      <tab-gathering-trailer-base v-if="job.containerLoadType === 'TT'" ref="tabGatheringTrailerBase" :context="context" :action="action" />
      <!-- 整车/零担基础-->
      <tab-less-than-carload-base v-if="job.containerLoadType === 'CL'" ref="tabLessThanCarloadBase" :context="context" :action="action" />
      <!-- 国际卡航基础-->
      <tab-international-card-base v-if="job.containerLoadType === 'IC'" ref="tabInternationalCard" :context="context" :action="action" />
    </template>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import aiBasicTab from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue'
import aiMasterBasicTab from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue'

import aeBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import aeTabGeneralUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralUICustom'
import aeMasterBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'
import aeTabMasterUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMasterUICustom'

import siBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab'
import siMasterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab'
import reTabBookingFcl from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL'
import reTabBookingMaster from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMaster'

import seBasicTab from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import seMasterBasicTab from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabBookingFcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import tabBookingFCLUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLUICustom'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabBookingMasterUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMasterUICustom'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import TabGatheringTrailerBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBase'
import TabLessThanCarloadBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarloadBase'
import TabInternationalCardBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBase'
import { cache, cacheName } from '@/utils/cacheManager'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'SalesQueryDetail',
  components: { TabInternationalCardBase, TabLessThanCarloadBase, TabGatheringTrailerBase, tabBookingMaster, tabBookingMasterUICustom, tabBookingFcl, tabBookingFCLUICustom, cargoAdvanceSelect, seBasicTab, seMasterBasicTab, reTabBookingFcl, reTabBookingMaster, siMasterBasicTab, aeMasterBasicTab, aeTabMasterUICustom, aiMasterBasicTab, aiBasicTab, aeBasicTab, aeTabGeneralUICustom, siBasicTab },
  props: {
    job: { type: Object, required: true },
    lob: { type: String, required: true, validator: (value) => { return ['AE', 'SE', 'SI', 'RE', 'RI', 'AI', ''].includes(value) } }, // AE SE SI RWE, ''(空字符串）为解决初始化警告问题
    masterFlag: { type: Boolean, required: true },
    context: { type: Object, required: false },
    showUiCustom: { type: Boolean, required: false }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      activeTabName: 'tabBookingFCL',
      action: 'look',
      bookingAgentVisible: false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.bookingAgentVisible = SalesUtil.salesCanBookingAgent(Number(cache.config.get('SalesCanSeeBookingAgent')) === 1)
      }
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.loading = getLoading()
      switch (this.lob) {
        case 'SE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'SI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabSiBasicMaster' : 'tabSiBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'AE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabAEBasicMaster' : 'tabAEBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'AI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabAIBasicMaster' : 'tabAIBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'RE':
        case 'RI': {
          const activeTabName = this.masterFlag ? 'reTabBookingMaster' : 'reTabBookingFcl'
          this.$refs[activeTabName].onShow(this.job, isRefresh)
          break
        }
        case 'IE': {
          let activeTabName = 'tabLessThanCarloadBase'
          if (this.job.containerLoadType === 'TT') {
            activeTabName = 'tabGatheringTrailerBase'
          } else if (this.job.containerLoadType === 'IC') {
            activeTabName = 'tabInternationalCard'
          }
          this.$refs[activeTabName].onShow(this.job, isRefresh)
          break
        }
      }
      this.loading.close()
    }
  }
}
</script>

<style lang="scss">
</style>
